export const msalConfig = {
  auth: {
    clientId: "7301420a-5e21-412b-b162-ecc4aaa1a9a8",
    authority: "https://podoanalysis.ciamlogin.com/3bcf193e-e522-4a23-934e-e96e17776f10/v2.0",
    knownAuthorities: ["podoanalysis.ciamlogin.com"],
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
